import React, { useState } from 'react';
import { Tool } from '../../types';
import './Sidebar.css';

interface SidebarProps {
  tools: Tool[];
  activeTool: string | null;
  onSelectTool: (toolId: string | null) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ tools, activeTool, onSelectTool }) => {
  const [collapsed, setCollapsed] = useState(false);
  
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };
  
  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="logo-container">
          {!collapsed && <span className="logo-text">CPS Tools</span>}
        </div>
        <button className="collapse-button" onClick={toggleSidebar}>
          {collapsed ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M6 12.796V3.204L11.481 8 6 12.796zm.659.753l5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"/>
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M9.204 11.5l-4.796-5.481L9.204 4.5v7zm1.753-.659l-4.796-5.48a1 1 0 0 0-1.506 0L4.654 5.5C4.089 6.148 4.55 7.16 5.408 7.16h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48z"/>
            </svg>
          )}
        </button>
      </div>
      
      <nav className="sidebar-nav">
        <ul className="nav-list">
          <li className="nav-section">
            {!collapsed && <h3 className="nav-section-title">Tools</h3>}
            <ul className="nav-items">
              {tools.map((tool) => (
                <li key={tool.id} className={`nav-item ${activeTool === tool.id ? 'active' : ''}`}>
                  <button
                    className="nav-link"
                    onClick={() => onSelectTool(tool.id)}
                    title={collapsed ? tool.name : undefined}
                  >
                    <span className="nav-icon">{tool.icon}</span>
                    {!collapsed && <span className="nav-label">{tool.name}</span>}
                    {!collapsed && tool.isNew && <span className="nav-badge new">New</span>}
                  </button>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </nav>
      
      <div className="sidebar-footer">
        {!collapsed && (
          <div className="sidebar-footer-content">
            <p className="version-info">v1.0.0</p>
          </div>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
